import { render, staticRenderFns } from "./secure-file-viewer.vue?vue&type=template&id=43ec6444&scoped=true&"
import script from "./secure-file-viewer.vue?vue&type=script&lang=ts&"
export * from "./secure-file-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./secure-file-viewer.vue?vue&type=style&index=0&id=43ec6444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec6444",
  null
  
)

export default component.exports